import Image from "next/image";
import React, { useRef, useState } from "react";

const AvatorComponentPreview = ({ baseURL, data }) => {
  const inputRef = useRef(null);
    const [previewImage, setPreviewImage] = useState(null);

  const handleImageChange = (event) => {};
  return (
    <div className="absolute left-1/2 top-0 z-10 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center">
      <figure className="relative h-40 w-40  border-white">
        {/* <Image
          width={141}
          height={141}
          src={baseURL + data.organization?.logoUrl}
          alt={data.shortDescription}
          className=" border-white object-cover h-40 w-full"
        /> */}
        <div className=" border-white object-cover h-40 w-full">
          {data != null && (
            <Image
              width={141}
              height={141}
              src={baseURL + data.organization?.logoUrl}
              alt={data.shortDescription}
              className="dark:border-jacarta-600 rounded-xl border-[5px] border-white object-cover h-40 w-full"
            />
          )}

          {/* Upload Image Layout */}

          {previewImage && (
            <div>
              <Image
                src={previewImage}
                alt="Preview"
                layout="fill"
                className="dark:border-jacarta-600 rounded-xl border-[5px] border-white object-cover h-40 w-full"
              />
            </div>
          )}
        </div>
        <div
          className="dark:border-jacarta-600 bg-green absolute -right-3 bottom-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
          data-tippy-content="Verified Collection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            className="h-[.875rem] w-[.875rem] fill-white"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
          </svg>
        </div>
      </figure>
    </div>
  );
};

export default AvatorComponentPreview;
